import { deleteCookieAtAllPaths } from './cookie-path-helper'
import { getCookie } from './get-cookie'

export function setCookie(
  cName: string,
  cValue: string,
  expireDate?: Date | number | string,
): boolean {
  if (typeof cName !== 'string' || cName.length === 0) {
    console.error('Cookie name is invalid.')
    return false
  }

  if (cValue === undefined || cValue === null || cValue === '') {
    console.warn(`Deleting cookie: ${cName}`)
    deleteCookieAtAllPaths(cName, [getCookie('targetUrl') ?? ''])
    return false
  }

  // Purge any same-named cookie at every plausible path before writing the
  // new path=/ cookie. See cookie-path-helper.ts for the full rationale —
  // legacy raw `document.cookie =` writes left path-scoped residues that
  // shadow fresh `path=/` cookies via longest-path-match (RFC 6265 §5.4).
  // We walk both the current URL and the `targetUrl` cookie (where the user
  // was when their session expired); from `/login`, only the targetUrl
  // walk can reach a residue at e.g. `/sales/orders/123`.
  deleteCookieAtAllPaths(cName, [getCookie('targetUrl') ?? ''])

  let date: Date
  if (expireDate instanceof Date) {
    date = expireDate
  } else if (typeof expireDate === 'number') {
    date = new Date(Date.now() + expireDate * 24 * 60 * 60 * 1000)
  } else if (typeof expireDate === 'string') {
    const parsed = new Date(expireDate)
    date = isNaN(parsed.getTime()) ? new Date(Date.now() + 10 * 60 * 60 * 1000) : parsed
  } else {
    date = new Date(Date.now() + 10 * 60 * 60 * 1000)
  }

  const cookieString = `${cName}=${cValue}; path=/; expires=${date.toUTCString()}; Secure; SameSite=Strict;`

  try {
    document.cookie = cookieString
    return true
  } catch (e) {
    console.error('Failed to set cookie:', e)
    return false
  }
}
